<template>
  <div class="issue-dashboard" :class="'issue-priority-' + issuePriority">
    <div class="issue-con-title">
      <div class="title-con">
        <i class="issue-priority" :class="'priority-' + issuePriority"></i>
        <div class="title-text">
          {{suggestOverview}}
          <p v-if="isIndex" class="title-desc">此列表部分数据小时级别或天级别更新，请稍后或次日查看。</p>
        </div>

      </div>
      <a v-if="isIndex" href="/v2/dist/suggest.html" target="_blank" rel="opener">前往投放建议页查看完整内容<i class="el-icon-arrow-right"></i></a>
    </div>
    <issue-container v-if="isShowP0" :issue-priority="1" :issue-list="adIssueMap.P0" :is-index="isIndex" :hasCharge="hasCharge" :show-pop="issueShowPop.p0"></issue-container>
    <issue-container v-if="isShowP1" :issue-priority="2" :issue-list="adIssueMap.P1" :is-index="isIndex" :hasCharge="hasCharge" :show-pop="issueShowPop.p1"></issue-container>
    <issue-container v-if="isShowP2" :issue-priority="3" :issue-list="adIssueMap.P2" :is-index="isIndex" :hasCharge="hasCharge" :show-pop="issueShowPop.p2"></issue-container>
  </div>
</template>
<script>
  import IssueContainer from './IssueContainer.vue';
  import {getAccountInfo} from '../utils/api.js';
  export default {
    name: 'issue-dashboard',
    props: {
      isIndex: Boolean,
      adIssueMap: Object,
      suggestOverview: String
    },
    data() {
      return {
        hasCharge: false,
      }
    },
    computed: {
      issuePriority () {
        return this.adIssueMap.P0 && this.adIssueMap.P0.length > 0 ? 1 : (
          this.adIssueMap.P1 && this.adIssueMap.P1.length > 0 ? 2 : (
            this.adIssueMap.P2 && this.adIssueMap.P2.length > 0 ? 3 : 0
          )
        )
      },
      issueShowPop() {
        const {P0, P1, P2} = this.adIssueMap;
        const p0Len = P0 && P0.length || 0;
        const p1Len = P1 && P1.length || 0;
        const p2Len = P2 && P2.length || 0;
        return {
          p0: this.isIndex && p0Len > 3,
          p1: this.isIndex && p0Len <= 3 && p1Len > 2,
          p2: this.isIndex && p0Len <= 3 && p1Len <= 2 && p2Len > 1
        }
      },
      isShowP0() {
        return this.adIssueMap.P0 && this.adIssueMap.P0.length > 0;
      },
      isShowP1() {
        return this.adIssueMap.P1 && this.adIssueMap.P1.length > 0;
      },
      isShowP2() {
        return this.adIssueMap.P2 && this.adIssueMap.P2.length > 0 && ((this.isIndex && (!this.isShowP0 || !this.isShowP1) ) || !this.isIndex);
      }
    },
    components: {
      IssueContainer
    },
    created() {
      this.getChargeAuth();
    },
    methods: {
      async getChargeAuth() {
        let data = await getAccountInfo();
        if (data) {
          this.hasCharge = data.accountCommonInfo.permission.includes('customer.recharge');
        }
      }
    }
  }
</script>
<style lang="scss">
  .issue-dashboard {
    width: 100%;
    height: 100%;
    padding: 20px 24px;
    margin-top: 20px;
    border-radius: 14px;
    .title-text {
      .title-desc {
        font-size: 12px;
        color: #afafafe6;
      }
    }
    &.issue-priority-0 {
      background: linear-gradient(93.76deg, #EBFDF0 0.89%, #CEF7DC 91.84%);
      .title-text {
        color: #03AF67;
      }
    }
    &.issue-priority-1 {
      background: linear-gradient(93.76deg, #FCEEE5 0.89%, #F7D1CE 91.84%);
      .title-text {
        color: #D72121;
      }
    }
    &.issue-priority-2 {
      background: linear-gradient(93.76deg, #FCF3E5 0.89%, #F7E4CE 91.84%);
      .title-text {
        color: #D78321;
      }
    }
    &.issue-priority-3 {
      background: linear-gradient(93.76deg, #EBFCFD 0.89%, #CEE6F7 91.84%);
      .title-text {
        color: #2479E1;
      }
    }
    .issue-con-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .title-con {
        display: flex;
        align-items: center;
      }
      .issue-priority {
        display: inline-block;
        width: 54px;
        height: 54px;
        &.priority-0 {
          background: url('../assets/img/priority_0.png') no-repeat;
        }
        &.priority-1 {
          background: url('../assets/img/priority_1.png') no-repeat;
        }
        &.priority-2 {
          background: url('../assets/img/priority_2.png') no-repeat;
        }
        &.priority-3 {
          background: url('../assets/img/priority_3.png') no-repeat;
        }
      }
      .title-text {
        padding-left: 20px;
        font-size: 18px;
        line-height: 22px;
        font-weight: 600;
        .sub-text {
          font-size: 14px;
          color: #9D9D9D;
          font-weight: 400;
        }
      }
      .el-icon-warning-outline {
        padding-left: 6px;
        font-size: 18px;
        color: #00000099;
      }
    }
  }
  .el-popover.issue-popover {
    font-size: 12px;
    padding: 12px 20px 10px 16px;
    color: #fff;
    line-height: 20px;
    background: #0052D9;
    border-radius: 12px;
    .text {
      margin-bottom: 6px;
    }
    .el-button--primary {
      width: 64px;
      height: 24px;
      padding: 0;
      background-color: #fff;
      color: #0052D9;
      border-color: #fff;
      border-radius: 12px;
      &:hover, &:focus {
        background: #4f8df1;
        border-color: #4f8df1;
        color: #fff;
      }
    }
    &.el-popper[x-placement^="bottom"] .popper__arrow {
      border-bottom-color: #0052D9;
      &::after {
        border-bottom-color: #0052D9;
      }
    }
  }
</style>